// hack way, need to be reworked in future
// TODO: https://jira.wixpress.com/browse/ECL-1169
import { StylableHorizontalMenuProps } from '../../StylableHorizontalMenu.types';

const getSelectorContent = (cssText: string, selector: string): string => {
  const execResult = new RegExp(`${selector}\\s*\\{(.*?)\\}`, 's').exec(
    cssText,
  );
  return execResult ? execResult[1] : '';
};

export const getInlineStyle = (inlineStyles: string) =>
  inlineStyles
    .replace(/&amp;/g, '&')
    .replace(/&quot;/g, '"')
    .split(';')
    .reduce<Record<string, string>>((styles, attr) => {
      const trimmedAttr = attr.trim();

      if (!trimmedAttr) {
        return styles;
      }

      const [name, value] = trimmedAttr.split(':');
      if (name && value) {
        styles[name.trim()] = value.trim().replace('px', '');
      }

      return styles;
    }, {});

export function parseValueFromCss(
  cssText: string,
  selector: string,
  key: string,
  fallbackValue: string | number,
) {
  const rules = getSelectorContent(
    cssText,
    selector ? `.root::${selector}` : '.root',
  );
  const styles = getInlineStyle(rules);
  const res = styles[key];
  if (!res) {
    return fallbackValue;
  }
  return typeof fallbackValue === 'number' ? Number.parseInt(res, 10) : res;
}

export const parseFlyoutAlignment = (cssText: string) =>
  parseValueFromCss(
    cssText,
    'columnsLayout',
    '--flyoutAlignment',
    'left',
  ) as StylableHorizontalMenuProps['flyoutAlignment'];
